document.addEventListener("DOMContentLoaded", function () {

  const design = document.getElementById("v2-design");
  const canvas = document.querySelector(".v2-canvas");
  const shirt = document.getElementById("v2-shirt");

  const colorSelect = document.getElementById("v2-color");
  const frontBtn = document.getElementById("v2-front");
  const backBtn = document.getElementById("v2-back");

  const saveBtn = document.getElementById("v2-save");
  const cartBtn = document.getElementById("v2-cart");

  window.v2FrontDesign = null;
  window.v2BackDesign = null;
  window.designId = null;

  let currentView = "front";

  let frontState = { posX: 160, posY: 210, scale: 1, design: null };
  let backState  = { posX: 160, posY: 210, scale: 1, design: null };

  let posX = frontState.posX;
  let posY = frontState.posY;
  let scale = frontState.scale;

  function updateShirt() {
    const color = colorSelect.value.toLowerCase();
    shirt.src = window.pp5Shirts[currentView][color];
  }

  colorSelect.addEventListener("change", updateShirt);
  updateShirt();

  function saveState() {
    const state = currentView === "front" ? frontState : backState;
    state.posX = posX;
    state.posY = posY;
    state.scale = scale;
    state.design = design.src;
  }

  function loadState(view) {
    const state = view === "front" ? frontState : backState;

    posX = state.posX;
    posY = state.posY;
    scale = state.scale;

    if (state.design) design.src = state.design;

    updateTransform();
  }

  function switchView(view) {
    saveState();
    currentView = view;

    frontBtn.classList.toggle("active", view === "front");
    backBtn.classList.toggle("active", view === "back");

    loadState(view);
    updateShirt();
  }

  frontBtn.onclick = () => switchView("front");
  backBtn.onclick = () => switchView("back");

  let isDragging = false;

  function updateTransform() {
    design.style.left = posX + "px";
    design.style.top = posY + "px";
    design.style.transform = `translate(-50%, -50%) scale(${scale})`;
  }

  design.addEventListener("mousedown", () => isDragging = true);
  document.addEventListener("mouseup", () => isDragging = false);

  document.addEventListener("mousemove", (e) => {
    if (!isDragging) return;

    const rect = canvas.getBoundingClientRect();
    posX = e.clientX - rect.left;
    posY = e.clientY - rect.top;

    updateTransform();
  });

  design.addEventListener("wheel", (e) => {
    e.preventDefault();

    scale += e.deltaY * -0.001;
    scale = Math.min(Math.max(0.3, scale), 3);

    updateTransform();
  });

  /* TOUCH */

  let isTouchDragging = false;
  let lastTouchDistance = null;

  design.addEventListener("touchstart", function (e) {

    if (e.touches.length === 1) {
      isTouchDragging = true;
    }

    if (e.touches.length === 2) {
      const dx = e.touches[0].clientX - e.touches[1].clientX;
      const dy = e.touches[0].clientY - e.touches[1].clientY;
      lastTouchDistance = Math.sqrt(dx * dx + dy * dy);
    }

  }, { passive: false });

  design.addEventListener("touchmove", function (e) {

    const rect = canvas.getBoundingClientRect();

    if (e.touches.length === 1 && isTouchDragging) {
      posX = e.touches[0].clientX - rect.left;
      posY = e.touches[0].clientY - rect.top;
      updateTransform();
      e.preventDefault();
    }

    if (e.touches.length === 2) {

      const dx = e.touches[0].clientX - e.touches[1].clientX;
      const dy = e.touches[0].clientY - e.touches[1].clientY;

      const dist = Math.sqrt(dx * dx + dy * dy);

      if (lastTouchDistance) {
        const delta = dist - lastTouchDistance;

        scale += delta * 0.005;
        scale = Math.min(Math.max(0.3, scale), 3);

        updateTransform();
      }

      lastTouchDistance = dist;
      e.preventDefault();
    }

  }, { passive: false });

  design.addEventListener("touchend", function () {
    isTouchDragging = false;
    lastTouchDistance = null;
  });

  /* =========================
  SAVE (FIXED)
  ========================= */
saveBtn.onclick = async function () {

  if (!design.src) {
    alert("Please select a design first");
    return;
  }

  saveBtn.innerText = "Saving...";
  saveBtn.disabled = true;

  try {

    /* 🔥 GENERATE ID */
    if (!window.designId) {
      window.designId = Date.now();
    }

    const rect = canvas.getBoundingClientRect();

    /* 🔥 CREATE EXPORT CANVAS */
    const exportCanvas = document.createElement("canvas");
    const ctx = exportCanvas.getContext("2d");

    exportCanvas.width = 1200;   // HD
    exportCanvas.height = 1400;

    const scaleFactorX = exportCanvas.width / rect.width;
    const scaleFactorY = exportCanvas.height / rect.height;

    /* =========================
    DRAW SHIRT
    ========================= */

    const shirtImg = new Image();
    shirtImg.crossOrigin = "anonymous";
    shirtImg.src = shirt.src;

    await new Promise(res => shirtImg.onload = res);

    ctx.drawImage(
      shirtImg,
      0,
      0,
      exportCanvas.width,
      exportCanvas.height
    );

    /* =========================
DRAW DESIGN (EXACT USER POSITION)
========================= */

const designImg = new Image();
designImg.crossOrigin = "anonymous";
designImg.src = design.src;

await new Promise(res => designImg.onload = res);

/* 🔥 GET REAL RENDERED POSITION + SIZE */
const designRect = design.getBoundingClientRect();
const canvasRect = canvas.getBoundingClientRect();

/* 🔥 SIZE (what user actually sees) */
const designW = designRect.width * scaleFactorX;
const designH = designRect.height * scaleFactorY;

/* 🔥 POSITION (relative to canvas) */
/*const offsetX = designRect.left - canvasRect.left;
const offsetY = designRect.top - canvasRect.top;

const drawX = offsetX * scaleFactorX;
const drawY = offsetY * scaleFactorY;*/
const isMobile = window.innerWidth < 768;

/* base position */
let offsetX = designRect.left - canvasRect.left;
let offsetY = designRect.top - canvasRect.top;

/* 🔥 FIX: mobile correction */
if (isMobile) {
  offsetX += 12;   // move right
  offsetY += 9;   // move down
}

const drawX = offsetX * scaleFactorX;
const drawY = offsetY * scaleFactorY;

/* 🔥 DRAW EXACTLY */
ctx.drawImage(
  designImg,
  drawX,
  drawY,
  designW,
  designH
);

    /* =========================
    EXPORT IMAGE
    ========================= */

    const finalImage = exportCanvas.toDataURL("image/png", 1.0);

    /* =========================
    SEND TO SERVER
    ========================= */

    const form = new FormData();
    form.append("image", finalImage);
    form.append("design_id", window.designId);
    form.append("side", currentView);

    const res = await fetch("https://back-apis.printpromp.com/upload-design.php", {
      method: "POST",
      body: form
    });

    const data = await res.json();

    if (data.status === "success") {
      saveBtn.innerText = "Saved ✓";
    } else {
      throw new Error(data.error || "Save failed");
    }

  } catch (err) {
    console.error(err);
    saveBtn.innerText = "Error ❌";
  }

  setTimeout(() => {
    saveBtn.innerText = "Save";
    saveBtn.disabled = false;
  }, 1500);
};
 
  /* =========================
  ADD TO CART
  ========================= */

  cartBtn.onclick = async function () {

  if (!window.designId) {
    alert("Please save design first");
    return;
  }

  const form = new FormData();

  const color = colorSelect.value.toLowerCase();
  const variantId = window.pp5Variants[color] || window.pp5Variant;

  form.append("id", variantId);
  form.append("quantity", 1);

  /* 🔥 ONLY STORE ID */
  form.append("properties[Design ID]", window.designId);
// ✅ ADD THIS BACK (CRITICAL)
const previewImage = window.v2FrontDesign || window.v2BackDesign;
form.append("properties[Preview]", previewImage);


  form.append("properties[Color]", color);

  await fetch("/cart/add.js", {
    method: "POST",
    body: form
  });

  window.location.href = "/cart";
};

});